/** Whether the signed-in user may run company onboarding (setup wizard). */

import { IS_LOCAL_DEV, isLocalDevEndUserPersona } from "@/config/localDev";
import type { Permission } from "@/hooks/useRbac";

/** BFF gate for setup mutations and admin-oriented status hints (D18). */
export const ONBOARDING_SETUP_PERMISSION = "iq:company:integration:read";

function permissionNamesFromBuckets(
  permissionBuckets: Permission[][] | undefined,
): Set<string> {
  const names = new Set<string>();
  for (const bucket of permissionBuckets ?? []) {
    for (const entry of bucket) {
      if (entry?.name) {
        names.add(entry.name);
      }
    }
  }
  return names;
}

/**
 * True when this user should see setup CTAs (banner, rail) and progress copy.
 *
 * Matches the BFF setup gate (`iq:company:integration:read`). Users with only
 * `WRITE_USERMANAGEMENT` still see `setupIncompleteMessage` but must not hit
 * setup mutations that would 403.
 * Local dev creator persona bypasses the permission list.
 */
export function userCanRunOnboardingSetup(
  permissionBuckets?: Permission[][],
): boolean {
  if (IS_LOCAL_DEV && !isLocalDevEndUserPersona()) {
    return true;
  }

  const names = permissionNamesFromBuckets(permissionBuckets);
  if (names.has(ONBOARDING_SETUP_PERMISSION)) {
    return true;
  }

  return false;
}
